import React, { useEffect, useState } from 'react';
import { WidgetSize } from '../../../types/Dashboard';
import { useAuth } from '../../../contexts/AuthContext';

interface TableWidgetProps {
  config: {
    tableType?: string;
  };
  size: WidgetSize;
}

const TableWidget: React.FC<TableWidgetProps> = ({ config, size }) => {
  const { userProfile } = useAuth();
  const [data, setData] = useState<any[]>([]);
  const [columns, setColumns] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.tableType, userProfile?.empresaCnpj]);

  const loadTableData = async () => {
    if (!userProfile?.empresaCnpj || !config.tableType) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setData([]);
      setColumns([]);
    } catch (error) {
      console.error('Erro ao carregar dados da tabela:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-300"></div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="flex-1 overflow-auto min-h-0">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              {columns.map((col, index) => (
                <th key={index} className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((row, index) => (
              <tr key={index} className="hover:bg-gray-50">
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className="px-4 py-2 text-sm text-gray-900">
                    {row[col] || '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {data.length === 0 && (
          <div className="text-center py-8 text-gray-500 text-sm">
            Nenhum dado disponível
          </div>
        )}
      </div>
    </div>
  );
};

export default TableWidget;

